<template>
  <div v-if="item" class="item-summary">
    <div>{{coverStyle | capitalize}}</div>
    <div>{{bindingType | capitalize}}</div>
    <div>{{dimentions}}</div>
    <div>{{pages}}</div>
    <div>{{color}}</div>
    <div>{{printing}}</div>
    <div>{{bleed}}</div>
    <div>{{frontCover}}</div>
    <div>{{backCover}}</div>
  </div>
</template>

<script>
export default {
  props: {
    item: Object
  },

  computed: {
    valid () {
      return this.item.file
    },

    file () {
      return this.item.file
    },

    unitPrice () {
      return this.item.unit_price
    },

    coverStyle () {
      return this.file.cover_style || this.file.cover || 'Softcover'
    },

    bindingType () {
      return this.file.binding + ' Binding'
    },

    printing () {
      if (this.file.printing === 'single') return 'Single-Sided Printing'
      if (this.file.single_side === true) return 'Single-Sided Printing'
      return 'Double-Sided Printing'
    },

    color () {
      if (this.file.ink === 'black') return `Black & White Printing`
      return 'Full-Color Printing'
    },

    bleed () {
      if (this.file.bleed === 'none') return 'Print As Is (White Borders)'
      if (this.file.full_bleed === false) return 'Print As Is (White Borders)'
      return 'Print-To-Edge (Borderless)'
    },

    pages () {
      return `${this.file.content_pages} Pages`
    },

    pageWidth () {
      if (this.file.width) return this.item.file.width
      return '8.5'
    },

    pageLength () {
      if (this.file.length) return this.item.file.length
      return '11'
    },

    dimentions () {
      return this.item.dimentions
    },

    frontCover () {
      if (this.file.first_page === 'copy') return 'Copy First Page For Front Cover'
      if (this.file.first_page === 'use') return 'Use First Page As Front Cover'
      return 'Copy First Page For Front Cover'
    },

    backCover () {
      if (this.file.last_page === 'copy') return 'Copy Last Page For Back Cover'
      if (this.file.last_page === 'use') return 'Use Last Page As Back Cover'
      if (this.file.last_page === 'blank') return 'No Artwork On Back Cover'
      return 'No Artwork On Back Cover'
    }
  }
}
</script>



// WEBPACK FOOTER //
// item-summary.vue?1c9521f5